import type { InputState } from '../core/GameContext';

export class InputController {
  constructor(private readonly canvas: HTMLCanvasElement, private readonly input: InputState, private readonly width: number, private readonly height: number, private readonly observe?: (action: 'fire_start'|'fire_stop', method?: string) => void) {
    canvas.addEventListener('pointermove', this.onPointerMove); canvas.addEventListener('pointerdown', this.onPointerDown);
    window.addEventListener('pointerup', this.onPointerUp); canvas.addEventListener('contextmenu', this.onContextMenu);
    window.addEventListener('blur', this.onBlur);
  }
  destroy(): void {
    this.canvas.removeEventListener('pointermove', this.onPointerMove); this.canvas.removeEventListener('pointerdown', this.onPointerDown);
    window.removeEventListener('pointerup', this.onPointerUp); this.canvas.removeEventListener('contextmenu', this.onContextMenu);
    window.removeEventListener('blur', this.onBlur);
  }
  private updatePointer(event: PointerEvent): void {
    const bounds = this.canvas.getBoundingClientRect();
    this.input.pointerX = Math.max(0, Math.min(this.width, ((event.clientX - bounds.left) / bounds.width) * this.width));
    this.input.pointerY = Math.max(0, Math.min(this.height, ((event.clientY - bounds.top) / bounds.height) * this.height));
  }
  private readonly onPointerMove = (event: PointerEvent): void => this.updatePointer(event);
  private readonly onPointerDown = (event: PointerEvent): void => { this.updatePointer(event); if (event.button === 0) { if (!this.input.firing) this.observe?.('fire_start', event.pointerType); this.input.firing = true; } };
  private readonly onPointerUp = (event: PointerEvent): void => { if (event.button === 0) { if (this.input.firing) this.observe?.('fire_stop', event.pointerType); this.input.firing = false; } };
  private readonly onContextMenu = (event: MouseEvent): void => event.preventDefault();
  private readonly onBlur = (): void => { if (this.input.firing) this.observe?.('fire_stop'); this.input.firing = false; };
}
